<template>
  <div v-if="loading" class="spinner-container">
    <div class="spinner"></div>
  </div>
  <div v-else>
    <div class="homepage d-flex flex-column vh-100">
      <!-- Navbar -->
      <div class="homepage-navbar bg-light shadow  p-3 bg-primary ">
        <div class="d-flex align-items-center">
          <span @click="goBack()" class="text-white">
            <i class="bi bi-arrow-left fs-5"></i>
          </span>
          &nbsp; &nbsp;
          <span>
            <h4 class="text-white">{{ language?.customer_history }}</h4>
          </span>
          <div class="d-flex align-items-center gap-2 ms-auto"></div>
        </div>
      </div>

      <!-- Body -->
      <div class="mt-2 my-auto overflow-auto">
        <div class="container pt-0" ref="captureArea">
          <!-- Laundry Details -->
          <div class="row">
            <div class="col-4">
          <img  v-if="!imagePreview" :src="$asset_path+'addlaundry/' +laundry_details.img" alt="Order Image" height="100px">
          </div>
          <div class="col-8">
          <h3 class="p-0 m-0">{{ laundry_details?.name }}</h3>
          <p class="p-0 m-0">{{ laundry_details?.address }}</p>
          <p class="p-0 m-0"><i class="bi bi-phone"></i> {{ laundry_details?.contact }}</p>
          </div>
          </div>
          <hr />

          <!-- Order Details -->
          <div class="card-body pt-1">
            <div class="row">
           
              <div class="col-12 pt-2">
                <label>{{ language?.create_cutomer_name }}</label>
                <div><b>{{ customer_row?.name }}</b></div>
              </div>
              <div class="col-6">
                <label>{{ language?.create_cutomer_cell }}</label>
                <div><b>{{ customer_row?.contact }}</b></div>
              </div>
              <div class="col-6">
                <label>{{ language?.create_cutomer_address }}</label>
                <div><b>{{ customer_row?.address }}</b></div>
              </div>

              <!--<div class="col-6 pt-2">-->
              <!--  <label class="form-label">{{ language?.create_order_date }}</label>-->
              <!--  <div><b>{{ order?.billdate }}</b></div>-->
              <!--</div>-->
              <div class="col-6 pt-2">
                   <b>{{ (order?.deliverydate )? language?.create_order_delv_date+' : '+order?.deliverydate :'' }}</b> 
              </div>
            </div>

            <div class="container bottom_border pt-2 pb-2"></div>

            <!-- Product & Service List -->
             <div class="container">
            <table class="table table-bordered">
                <thead class="text-danger">
                  <tr>
                    <th>{{ language?.tr_date }}</th>
                    <th>{{ language?.remark }}</th>
                    <th>{{ language?.total }}</th>
                    <th>{{ language?.paid }}</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(item, i) in accountingList" :key="item.id">
                    <tr v-if="item.qty != 0">
                      <td>{{ item.id }} / {{ item.billdate }}</td>
                      <td>{{ item.billno>0 ?   'Order Id #' + item.billno:item.remark }}</td>
                      <td>{{ item.total }}</td>
                      <td>{{ item.paid }}</td>
                    </tr>
                  </template>
                </tbody>
              </table>
              </div>
              

            <!-- Summary Section -->
            <template v-for="(item, i) in accountingTrList" :key="item.id">
            <div class="row pt-2">
              <div class="col-4">
                <label class="form-label">{{ language?.total_amount }}</label>
                <div><b>₹.{{ item.total_amt }}</b></div>
              </div>
              <div class="col-4">
                <label class="form-label">{{ language?.paid_amount }}</label>
                <div><b>₹.{{ item.paid_amt }}</b></div>
              </div>
              <div class="col-4">
                <label class="form-label">{{ language?.due_amt }}</label>
                <div><b>₹.{{ item.due_amt }}</b></div>
              </div>
             
            </div>
        </template>
            <hr />
            <p class="text-center">Thank You, Visit Again...</p>
          </div>
        </div>

        <!-- Capture & Share Button -->
        <div class="text-center mt-3">
          <button class="btn btn-primary" @click="captureView">
            <i class="bi bi-share"></i> Capture & Share
          </button>
           <button class="btn btn-success" style="margin-left: 5px;" @click="genratepdf">
        <i class="bi bi-whatsapp"></i> Genrate pdf
      </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.bottom_border{
        border-bottom: 1px solid gray;
}
.footer_area{
        position: fixed;
        width: -webkit-fill-available;
        bottom: 0;
        background: aliceblue;
        padding: 5px 10px;
}
    .custom_height {
           min-height: 80vh;
        max-height: 80vh;
        overflow-y: auto;
    }
</style>
<script>
import axios from "@/plugins/axios"; 
import html2canvas from "html2canvas";

  export default {
    name: 'Branch',
    components: {
    },
    
    
    mounted() {
      //  this.fetchWeather();
      if(this.$route.query.id)
            this.getOrderDetails(this.$route.query.id); // Call the method here

    }, 
    data() {
      return { 
        loading: false,
        error: null,
        accountingList:[],
        accountingTrList:[],
        order:[],
        laundry_details:[],
        language:this.getLocalStorageArray('lang'),
        customer_row:[],
      }
    },
    methods: {
      initializeHomeContent() {


      },
      goBack() {
          
          this.$router.go(-1);
  },
        
        async captureView() {
      const element = this.$refs.captureArea; // Select the element to capture

      html2canvas(element, { useCORS: true }).then((canvas) => {
        canvas.toBlob((blob) => {
          if (!blob) return;

          // Create a File object from the blob
          const file = new File([blob], "bill_print.png", { type: "image/png" });

          // Check if Web Share API is supported
          if (navigator.canShare && navigator.canShare({ files: [file] })) {
            navigator
              .share({
                 title: "Order No: #"+self.order,
                  text: self.share_msg,
                files: [file],
              })
              .catch((err) => console.error("Sharing failed", err));
          } else {
            // Fallback to download if sharing is not supported
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = "bill_print.png";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        }, "image/png");
      });
    },  
      
        
      async getOrderDetails(custid) {
        this.loading = true;
        this.error = null;

        try {
          var self = this;
          axios.post("getCustomerDetails",{custid:custid}).then((response) => {
            
            self.accountingList = response.data.accountingList;
            self.customer_row = response.data.customer_row;
            self.laundry_details = response.data.laundry_details;
            self.accountingTrList = response.data.accountingTrList;
           
            
                     self.language=response.data.language;
                     localStorage.setItem('lang',response.data.language);

          }).then(() => { 
          }).catch((err) => {

          });;


        } catch (err) {
          this.error = err.response?.data?.message || "Login failed. Please try again.";
        } finally {
          this.loading = false;
        }
      },


      
      getLocalStorageArray(key) {
        let data = localStorage?.getItem(key);
        try {
            return data ? JSON.parse(data) : [];
        } catch (e) {
            console.error("Error parsing localStorage data", e);
            return [];
        }
    },
    

//04.04.2025
  shareOnWhatsApp(phoneNumber) {
          
        
            if(phoneNumber){
              if(phoneNumber.length==10)
                  phoneNumber="91"+phoneNumber;
                  const message = `Hello, here is your laundry bill report. Please download it from: ${this.assetpath+""+this.pdf_file}`;
                  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
                  window.open(whatsappUrl, "_blank");
                }
            },
        
        
 genratepdf() {
        this.loading = true;
        this.error = null;
  
        try {
           var self=this;
            axios.post("generateStatementPdfReport",self.customer_row).then((response) => {
               
              if(response.data.success==1){
                self.pdf_file=response.data.pdf_file;   
                self.assetpath=response.data.assetpath;   
                self.shareOnWhatsApp(response.data.customer_row.contact); 
                
              } else{
                    self.$swal.fire(response.data.message);
              }
              
                  
               
        
          }).then(() => {
              
          }).catch((err) => {
            
          });;
         

        } catch (err) {
          this.error = err.response?.data?.message || "Login failed. Please try again.";
        } finally {
          this.loading = false;
        }
      }, 
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    

    }
  }






</script>